// Define the possible component actions for the reducer to call.
export const ACTIONS = {
  ATTEMPT_LOGIN: "attemptLogin",
  CLEAR_STATUS: "clearStatus",
  INPUT_PASSWORD: "inputPassword",
  INPUT_USERNAME: "inputUsername",
  LOGIN_ACCOUNT_DISABLED: "loginAccountDisabled",
  LOGIN_ERROR: "loginError",
  LOGIN_SUCCESS: "loginSuccess",
};

// Define the state's initial values.
export const initialState = {
  formValid: false,
  loading: false,
  password: "",
  status: "",
  username: "",
};

// Method returning boolean for the form's validity status.
const CheckForm = (username, password) => {
  try {
    return (
      username !== undefined &&
      username.length > 0 &&
      password !== undefined &&
      password.length > 0
    );
  } catch {
    return false;
  }
};

// Define the component's reducer with an actions to update state.
export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.INPUT_USERNAME:
      return {
        ...state,
        status: "",
        error: initialState.error,
        username: action.value,
        formValid: CheckForm(action.value, state.password),
      };
    case ACTIONS.INPUT_PASSWORD:
      return {
        ...state,
        status: "",
        password: action.value,
        formValid: CheckForm(state.username, action.value),
      };
    case ACTIONS.ATTEMPT_LOGIN:
      return {
        ...state,
        status: "",
        loading: true,
        formValid: false,
      };
    case ACTIONS.LOGIN_ERROR:
      return {
        ...state,
        status: action.value,
        loading: false,
        formValid: false,
        password: "",
      };
    case ACTIONS.LOGIN_SUCCESS:
      return {
        ...state,
        status: "",
        loading: false,
        formValid: false,
        username: "",
        password: "",
      };
    case ACTIONS.LOGIN_ACCOUNT_DISABLED:
      return {
        ...state,
        status: "Login denied: account is disabled!",
        loading: false,
        formValid: false,
        password: "",
      };
    case ACTIONS.CLEAR_STATUS:
      return {
        ...state,
        status: "",
      };
    default:
      return state;
  }
};
